import { navigationActions } from "../reducer";

export const resetLocationsHistory = () => navigationActions.resetHistory();
